module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "ct",
    attrs: {
      "id": "ch5"
    }
  }, [_c('span', {
    staticClass: "epub-bi"
  }, [_vm._v("Chapter V")])]), _vm._v(" "), _c('p', {
    staticClass: "vh1"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("I")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Major Plunkett gently settled his Guinness, wiped")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("the rime of gold foam freckling his pensioned moustache")]), _vm._v(" "), _c('p', {
    staticClass: "vsb"
  }, [_vm._v("with a surf-curling tongue. Adjacently, Maud sipped")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("quietly, wifely, an ale. Under the peaked thatch")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("designed like a kraal facing the weathered village,")]), _vm._v(" "), _c('p', {
    staticClass: "vsb"
  }, [_vm._v("the raffia decor was empty. He heard the squeak")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("of Maud’s weight when she shifted. The usual mirage")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("of clouds in full canvas steered towards Martinique.")]), _vm._v(" "), _c('p', {
    staticClass: "vsb"
  }, [_vm._v("This was their watering-hole, this rigid custom")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("of lowering the yardarm from the same raffia chairs")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("once a week at one, between the bank and the farm,")]), _vm._v(" "), _c('p', {
    staticClass: "vsb"
  }, [_vm._v("once Maud delivered her orchids, for all these years")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("of self-examining silence. Maud stirred the ends")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("of damp curls from her nape. The Major drummed the edge")]), _vm._v(" "), _c('p', {
    staticClass: "vsb"
  }, [_vm._v("of the bar and twirled a straw coaster. Their silence")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("was a mutual communion. They’d been out here")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("since the war and his wound. Pigs. Orchids. Their marriage")]), _vm._v(" "), _c('p', {
    staticClass: "vsb"
  }, [_vm._v("a silver anniversary of bright water")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("that glittered like Glen-da-Lough in Maud’s home county")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("of Wicklow, but for Dennis, in his khaki shirt")]), _vm._v(" "), _c('p', {
    staticClass: "vsb"
  }, [_vm._v("and capacious shorts in which he’d served with Monty,")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("the crusted tourists were corpses in the desert")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("from the Afrika Korps. "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Pro Rommel, pro mori.")])]), _vm._v(" "), _c('p', {
    staticClass: "vsb"
  }, [_vm._v("The regimental brandies stiffened on the shelves")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("near Napoleonic cognacs. All history")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("in a dusty Beefeater’s gin. We helped ourselves")]), _vm._v(" "), _c('p', {
    staticClass: "vsb"
  }, [_vm._v("to these green islands like olives from a saucer,")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("munched on the pith, then spat their sucked stones on a plate,")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("like a melon’s black seeds. "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Pro honoris causa,")])]), _vm._v(" "), _c('p', {
    staticClass: "vsb"
  }, [_vm._v("but in whose honour did his head-wound graduate?")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("This was their Saturday place, not a corner-pub,")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("not the wrought-iron Victoria. He had resigned")]), _vm._v(" "), _c('p', {
    staticClass: "vsb"
  }, [_vm._v("from that haunt of middle-clarse farts, an old club")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("with more pompous arses than any flea could find,")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("a replica of the Raj, with gins-and-tonic")]), _vm._v(" "), _c('p', {
    staticClass: "vsb"
  }, [_vm._v("from black, white-jacketed servitors whose sonic")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("judgement couldn’t distinguish a secondhand-car")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("salesman from Manchester from the phony pukka")]), _vm._v(" "), _c('p', {
    staticClass: "vsb"
  }, [_vm._v("tones of ex-patriates. He was no officer,")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("but he’d found himself saying things like “Luverly,”")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("“Right-o,” and, Jesus Christ, “Ta!” from a wicker chair,")]), _vm._v(" "), _c('p', {
    staticClass: "vsb"
  }, [_vm._v("with the other farts exchanging their brusque volley")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("in the class war. Every one of them a liar")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("dyeing his roots, their irrepressible Cockney,")]), _vm._v(" "), _c('p', {
    staticClass: "vsb"
  }, [_vm._v("overdoing impatience. Clods from Lancashire")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("surprised by servants, outpricing their own value")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("and their red-kneed wives with accents like cutlery")]), _vm._v(" "), _c('p', {
    staticClass: "vsb"
  }, [_vm._v("spilled from a drawer. For them, the fields of his valour,")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("the war in the desert under Montgomery,")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("and the lilac flowers under the crosses were")]), _vm._v(" "), _c('p', {
    staticClass: "vsb"
  }, [_vm._v("preserved by being pickled at the Victoria.")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("He’d played the officer’s pitch. Though he felt ashamed,")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("it paid off. The sand grit in his throat, the Rover,")]), _vm._v(" "), _c('p', {
    staticClass: "vsb"
  }, [_vm._v("all that sort of stuff. The khaki shorts that proclaimed")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("his forgotten service. Well, all that was over,")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("but not the class war that denigrated the dead")]), _vm._v(" "), _c('p', {
    staticClass: "vsb"
  }, [_vm._v("face down in the sand, beyond Alexandria.")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("The flags pinned to a map. The prone crosses")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("of tourists sprawled out far from the red lifeguard’s flag,")]), _vm._v(" "), _c('p', {
    staticClass: "vsb"
  }, [_vm._v("like those of his comrades with sand seaming their eyes.")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("What was it all for? A bagpipe’s screech and a rag.")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Well, why not? In war, the glory was the yeoman’s;")]), _vm._v(" "), _c('p', {
    staticClass: "vsb"
  }, [_vm._v("the kids from drizzling streets; they fell like those Yanks")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("in a sun twice as fierce, Tobruk and Alamein’s,")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("their corpses black in the shade of the shattered tanks,")]), _vm._v(" "), _c('p', {
    staticClass: "vsb"
  }, [_vm._v("their bodies dragged like towels to a palm-tree’s shade.")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Those lines of white surf raced like the applauding streets")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("alongside the Eighth Army when Montgomery broke")]), _vm._v(" "), _c('p', {
    staticClass: "vsb"
  }, [_vm._v("the back of the Afrika Korps. Blokes in white sheets")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("flinging caps like spray as we piped into Tobruk")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("and I leant on the tank turret while bagpipes screeched")]), _vm._v(" "), _c('p', {
    staticClass: "vsb"
  }, [_vm._v("ahead of those grinning Tommies. I wept with pride.")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Tears prickled his eyes. Maud reached across the saucer")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("and gripped his fingers. He knew she could see inside")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("the wound in his head. His white nurse. His officer.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("II")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Not club-mates. Chums, companions. Comrades-in-arms.")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("They crouched, hands on helmets, while the Messerschmitt’s gun")]), _vm._v(" "), _c('p', {
    staticClass: "vsb"
  }, [_vm._v("stitched, in staccato succession, miniature palms")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("along the top of the trench. He shot up. Again")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Tumbly pulled him down. “Just keep yer bleedin’ ’ead low!”")]), _vm._v(" "), _c('p', {
    staticClass: "vsb"
  }, [_vm._v("Scott was running to them, laughing, but the only thing")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("funny about him was the fact that one elbow")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("didn’t have the rest of the arm. He jerked the thing")]), _vm._v(" "), _c('p', {
    staticClass: "vsb"
  }, [_vm._v("from the stump, mimicking a Kraut salute; then, as")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("his astonishment passed, he sagged down from the knees")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("with that grin. And I turned to Tumbly and his eyes")]), _vm._v(" "), _c('p', {
    staticClass: "vsb"
  }, [_vm._v("were open but not moving; then an awful noise")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("lifted all of us up from the sand and I guess")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("I was hit then, but I could remember nothing")]), _vm._v(" "), _c('p', {
    staticClass: "vsb"
  }, [_vm._v("for months, in casualty. Oh yes! that business")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("of Tumbly’s eyes. The sky in them. Scottie laughing.")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Tell them that at the Victoria, in the noise")]), _vm._v(" "), _c('p', {
    staticClass: "vsb"
  }, [_vm._v("of ice-cubes tinkling and the draft-beer frothing.")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("This wound I have stitched into Plunkett’s character.")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("He has to be wounded, affliction is one theme")]), _vm._v(" "), _c('p', {
    staticClass: "vsb"
  }, [_vm._v("of this work, this fiction, since every “I” is a")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("fiction finally. Phantom narrator, resume:")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Tumbly. Blue holes for his eyes. And Scottie wiser")]), _vm._v(" "), _c('p', {
    staticClass: "vsb"
  }, [_vm._v("when the shock passed. Plain men. Not striking. Not handsome.")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Through the Moorish arches of the hospital ward,")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("with a cloud wrapped around his head like an Arab,")]), _vm._v(" "), _c('p', {
    staticClass: "vsb"
  }, [_vm._v("he saw the blue Mediterranean, then Maud")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("lying on her back on the cliff and the scarab")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("of the troop ship far on the roadstead. Two days’ leave")]), _vm._v(" "), _c('p', {
    staticClass: "vsb"
  }, [_vm._v("before they set out, and he thought he would never")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("see her again, but if he did, a different life")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("had to be made whenever the war was over,")]), _vm._v(" "), _c('p', {
    staticClass: "vsb"
  }, [_vm._v("even if it lasted ten years, if she would wait,")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("not on this grass cliff but somewhere on the other")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("side of the world, somewhere, with its sunlit islands,")]), _vm._v(" "), _c('p', {
    staticClass: "vsb"
  }, [_vm._v("where what they called history could not happen. Where?")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Where could this world renew the Mediterranean’s")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("innocence? She deserved Eden after this war.")]), _vm._v(" "), _c('p', {
    staticClass: "vsb"
  }, [_vm._v("Past that islet out there was the Battle of the Saints.")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Old Maud was ruddy as a tea-rose; once her hair")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("was gold as a beer-stein in firelight, but now")]), _vm._v(" "), _c('p', {
    staticClass: "vsb"
  }, [_vm._v("she’d stretch a mapped arm from her nightdress. “It’s a rare")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("chart of the Seychelles or something.” “Oh, my love, no!”")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("“You are my tea-rose, my crown, my cause, my honour,")]), _vm._v(" "), _c('p', {
    staticClass: "vsb"
  }, [_vm._v("my desert’s white lily, the queen for whom I fought.”")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Sometimes the same old longing descended on her")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("to see Ireland. He set down his glass in the ring")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("of a fine marriage. Only a son was missing.")]), _vm._v(" "), _c('p', {
    staticClass: "vh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("III")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("How fast it fades! Maud thought; the enamelled sky,")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("the gilded palms, the bars like altars of raffia,")]), _vm._v(" "), _c('p', {
    staticClass: "vsb"
  }, [_vm._v("even for that Madonna bathing her baby")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("with his little shrimp thing! One day the Mafia")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("will spin these islands round like roulette. What use is")]), _vm._v(" "), _c('p', {
    staticClass: "vsb"
  }, [_vm._v("Dennis’s devotion when their own ministers")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("cash in on casinos with their old excuses")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("of more jobs? Their future felt as sinister as")]), _vm._v(" "), _c('p', {
    staticClass: "vsb"
  }, [_vm._v("that of that ebony girl in her yellow dress.")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("“There’s our trouble,” Maud muttered into her glass. In")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("a gust that leant the triangular sails of the")]), _vm._v(" "), _c('p', {
    staticClass: "vsb"
  }, [_vm._v("surfers, Plunkett saw the pride of Helen passing")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("in the same yellow frock Maud had altered for her.")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("“She looks better in it”—Maud smiled—“but the girl lies")]), _vm._v(" "), _c('p', {
    staticClass: "vsb"
  }, [_vm._v("so much, and she stole. What’ll happen to her life?”")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("“God knows,” said Plunkett, following the butterfly’s")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("yellow-panelled wings that once belonged to his wife,")]), _vm._v(" "), _c('p', {
    staticClass: "vsb"
  }, [_vm._v("the black V of the velvet back, near the shallows.")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Her head was lowered; she seemed to drift like a waif,")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("not like the arrogant servant that ruled their house.")]), _vm._v(" "), _c('p', {
    staticClass: "vsb"
  }, [_vm._v("It was at that moment that he felt a duty")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("towards her hopelessness, something to redress")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("(he punned relentlessly) that desolate beauty")]), _vm._v(" "), _c('p', {
    staticClass: "vsb"
  }, [_vm._v("so like her island’s. He drained the foaming Guinness.")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Seychelles. Seashells. One more. In the olive saucer,")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("the dry stones were piling up, their green pith sucked dry.")]), _vm._v(" "), _c('p', {
    staticClass: "vsb"
  }, [_vm._v("Got what we took from them, yes sir! Quick, because the")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Empire was ebbing. He watched the silhouette")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("of his wife, her fine profile set in an oval")]), _vm._v(" "), _c('p', {
    staticClass: "vsb"
  }, [_vm._v("ivory cloud, like a Victorian locket,")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("as when, under crossed swords, she lifted the lace veil.")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("The flag then was sliding down from the hill-stations")]), _vm._v(" "), _c('p', {
    staticClass: "vsb"
  }, [_vm._v("of the Upper Punjab, like a collapsing sail;")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("an elephant folded its knees, its striations")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("wrinkling like the tea-pavilions after the Raj,")]), _vm._v(" "), _c('p', {
    staticClass: "vsb"
  }, [_vm._v("whose ebbing surf lifted the coastlines of nations")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("as lacy as Helen’s shift. In the noon’s mirage")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("the golden palms shook their tassels, Eden’s Egypt")]), _vm._v(" "), _c('p', {
    staticClass: "vsb"
  }, [_vm._v("sank in the tinted sand. The Giza pyramids")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("darkened with the sharpening Pitons, as Achille shipped")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("both oars like rifles. Clouds of delivered Muslims")]), _vm._v(" "), _c('p', {
    staticClass: "vsb"
  }, [_vm._v("foamed into the caves of mosques, and honour and glory")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("faded like crested brandies. Then remorseful hymns")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("soared in the stone-webbed Abbey. "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Memento mori")])]), _vm._v(" "), _c('p', {
    staticClass: "vsb"
  }, [_vm._v("in the drumbeat of Remembrance Day. Pigeons whirr")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("over Trafalgar. Helen needed a history,")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("that was the pity that Plunkett felt towards her.")]), _vm._v(" "), _c('p', {
    staticClass: "vsb"
  }, [_vm._v("Not his, but her story. Not theirs, but Helen’s war.")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("The name, with its historic hallucination,")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("brightened the beach; the butterfly, to Plunkett’s joy,")]), _vm._v(" "), _c('p', {
    staticClass: "vsb"
  }, [_vm._v("twinkling from myrmidon to myrmidon, from one")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("sprawled tourist to another. Her village was Troy,")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("its smoke obscuring soldiers fallen in battle.")]), _vm._v(" "), _c('p', {
    staticClass: "vsb"
  }, [_vm._v("Then her unclouding face, her breasts were its Pitons,")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("the palms’ rusted lances swirled in the death-rattle")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("of the gargling shoal; for her Gaul and Briton")]), _vm._v(" "), _c('p', {
    staticClass: "vsb"
  }, [_vm._v("had mounted fort and redoubt, the ruined barracks")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("with its bushy tunnel and its penile cannon;")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("for her cedars fell in green sunrise to the axe.")]), _vm._v(" "), _c('p', {
    staticClass: "vsb"
  }, [_vm._v("His mind drifted with the smoke of his reverie")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("out to the channel. Lawrence arrived. He said:")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("“I changing shift, Major. Major?” Maud tapped his knee.")]), _vm._v(" "), _c('p', {
    staticClass: "vsb"
  }, [_vm._v("“Dennis. The bill.” But the bill had never been paid.")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Not to that housemaid swinging a plastic sandal")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("by the noon sea, in a dress that she had to steal.")]), _vm._v(" "), _c('p', {
    staticClass: "vsb"
  }, [_vm._v("Wars. Wars thin like sea-smoke, but their dead were real.")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("He smiled at the mythical hallucination")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("that went with the name’s shadow; the island was once")]), _vm._v(" "), _c('p', {
    staticClass: "vsb"
  }, [_vm._v("named Helen; its Homeric association")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("rose like smoke from a siege; the Battle of the Saints")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("was launched with that sound, from what was the “Gibraltar")]), _vm._v(" "), _c('p', {
    staticClass: "vsb"
  }, [_vm._v("of the Caribbean,” after thirteen treaties")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("while she changed prayers often as knees at an altar,")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("till between French and British her final peace")]), _vm._v(" "), _c('p', {
    staticClass: "vsb"
  }, [_vm._v("was signed at Versailles. All of this came to his mind")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("as Lawrence came staggering up the terrace")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("with the cheque finally, and that treaty was signed;")]), _vm._v(" "), _c('p', {
    staticClass: "vsb"
  }, [_vm._v("the paper was crossed by the shadow of her face")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("as it was at Versailles, two centuries before,")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("by the shade of Admiral Rodney’s gathering force;")]), _vm._v(" "), _c('p', {
    staticClass: "vsb"
  }, [_vm._v("a lion-headed island remembering war,")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("its crouched flanks tawny with drought, and on its ridge, grass")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("stirred like its mane. For a while he watched the waiter")]), _vm._v(" "), _c('p', {
    staticClass: "vsb"
  }, [_vm._v("move through the white iron shields of the white terrace.")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("In the village Olympiad, on St. Peter’s Day,")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("he served as official starter with a flare-gun")]), _vm._v(" "), _c('p', {
    staticClass: "vsb"
  }, [_vm._v("borrowed from the manager of the marina.")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("It wasn’t Aegean. They climbed no Parthenon")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("to be laurelled. The depot faced their arena,")]), _vm._v(" "), _c('p', {
    staticClass: "vsb"
  }, [_vm._v("the sea’s amphitheatre. When one wore a crown—")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("victor ludorum")]), _vm._v("—no one knew what it meant, or")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("cared to be told. The Latin syllables would drown")]), _vm._v(" "), _c('p', {
    staticClass: "vsb"
  }, [_vm._v("in the clapping dialect of the crowd. Hector")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("would win, or Achille by a hair; but everyone")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("knew as the crossing ovals of their thighs would soar")]), _vm._v(" "), _c('p', {
    staticClass: "vsb"
  }, [_vm._v("in jumps down the cheering aisle, or their marathon")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("six times round the village, that the true bounty was")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Helen, not a shield nor the ham saved for Christmas;")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("as one slid down the greased pole to factional roars.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ba1d400c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/chapter5.vue
// module id = 87
// module chunks = 0